import type { TabKeys, TabParamKeys } from "./TabKeys.type";

export const TAB_PARAM_KEYS = {
  CONTEXT_TAB_KEY: "tab",
  CONTEXT_SUBTAB_KEY: "sub_tab",
  CONTEXT_MENU_KEY: "menu",
  CONTEXT_DATASET_TYPE_KEY: "dataset_type",
} as const;

export const TAB_PARAM_KEYS_VALUES = Object.values(
  TAB_PARAM_KEYS
) as TabParamKeys[];

export const TAB_KEYS = {
  ACTIVITIES_CHANGES: "changes",
  ACTIVITIES_BATCH: "batch",
  ASSETS_TECHNICAL: "technical",
  ASSETS_COMPONENTS: "components",
  ASSETS_INTERVENTIONS: "interventions",
  ASSETS_OBSERVATIONS: "observations",
  ASSETS_TIMELINE: "timeline",
  INTERVENTIONS_DETAILS: "details",
  INTERVENTIONS_MODULES: "reports-modules",
  INTERVENTIONS_OBSERVATIONS: "observations",
  INTERVENTIONS_RECOMMENDATIONS: "recommended-interventions",
  LOCATION_MAP: "map",
  LOCATION_SECTORS: "sectors",
  LOCATION_ASSETS: "assets",
  LOCATION_INTERVENTIONS: "interventions",
  LOCATION_PROJECTS: "projects",
  MY_SPACE_INTERVENTIONS: "interventions",
  MY_SPACE_PROJECTS: "projects",
  MY_SPACE_RECENTS: "recents",
  MY_SPACE_FAVORITES: "favorites",
  OBSERVATIONS_SUMMARY: "summary",
  OBSERVATIONS_IMAGES: "images",
  OBSERVATIONS_POSITION: "position",
  OBSERVATIONS_COMMENTS: "comments",
  ORGANIZATIONS_LOCATIONS: "locations",
  ORGANIZATIONS_PROJECTS: "projects",
  ORGANIZATIONS_RISK_MATRIX: "risk-matrix",
  PREFERENCES_GENERAL: "general",
  PREFERENCES_PASSWORD: "password",
  PREFERENCES_NOTIFICATIONS: "notifications",
  PROJECTS_INTERVENTIONS: "interventions",
  TEMPLATE_DETAILS: "details",
  TEMPLATE_PREVIEW: "preview",
  TEMPLATE_FORM_EDITOR: "form-editor",
  TEMPLATE_EDITOR: "template-editor",
  TEMPLATE_JSON: "json-editor",
  TEMPLATE_SEVERITY_GRID: "severity-grid",
  TEMPLATE_SCHEMA: "schema",
  USERS_INTERVENTIONS: "interventions",
  USERS_ROLES: "roles",
} as const;

export const TAB_KEYS_VALUES = Object.values(TAB_KEYS) as TabKeys[];
